import React from 'react';

import { Default } from '../../../../../layouts';

import { useEditPage } from '../../../../../hooks/useEditPage';

import {
  findOne,
  create,
  update,
} from '../../../../../services/taxonomies/equipment/brands';
import EditEquipmentBrandForm from '../../../../../components/taxonomies/equipments/EditEquipmentBrandForm';

const initial = {};

const EditEquipmentBrand = () => {
  const [brand, handleSubmit, handleCancel] = useEditPage({
    initial,
    existent: findOne,
    goBackPath: '/admin/taxonomies/equipment/brands',
    onCreate: create,
    onUpdate: update,
  });

  return (
    <Default>
      {brand !== undefined && (
        <EditEquipmentBrandForm
          brand={brand}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </Default>
  );
};

export default EditEquipmentBrand;
